import { siInstagram, siMeta, siSpotify, siTiktok } from "simple-icons";

const BRAND_ICONS = {
  instagram: { icon: siInstagram, color: "#E4405F" },
  meta: { icon: siMeta, color: "#0866FF" },
  spotify: { icon: siSpotify, color: "#1DB954" },
  tiktok: { icon: siTiktok, color: "#111111" },
};

export default function BrandMark({ brand, className = "h-4 w-4" }) {
  const entry = BRAND_ICONS[brand];
  if (!entry) return null;

  return (
    <svg
      aria-label={entry.icon.title}
      className={className}
      fill="currentColor"
      role="img"
      style={{ color: entry.color }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={entry.icon.path} />
    </svg>
  );
}